import { tryOnScopeDispose, type MaybeRef } from '@vueuse/core'
import { removeBy } from '@shared/array'

export type EscapeListener = (event: KeyboardEvent) => void | boolean

const escapeListeners: [MaybeRef<boolean>, EscapeListener][] = []

function onKeydown (event: KeyboardEvent) {
  if (event.key === 'Escape' && !event.defaultPrevented) {
    for (const [maybeActive, listener] of escapeListeners) {
      if (unref(maybeActive) && !listener(event))
        return event.preventDefault()
    }
  }
}

export function onEscape (
  fn: EscapeListener,
  options: { active: MaybeRef<boolean> } = { active: true },
) {
  // If we are in SSR, we don't want to add any event listeners
  if (import.meta.env.SSR)
    return

  const listener: [MaybeRef<boolean>, EscapeListener] = [options.active, fn]

  if (escapeListeners.length === 0)
    addEventListener('keydown', onKeydown)

  escapeListeners.unshift(listener)

  const stop = () => {
    removeBy(escapeListeners, l => l === listener)

    if (escapeListeners.length === 0)
      removeEventListener('keydown', onKeydown)
  }

  tryOnScopeDispose(stop)

  return stop
}
